<div class="d-flex flex-column min-vh-100">
  <app-navbar></app-navbar>
  @if (isRouteLoading() || authStatus() === 'loading') {
    <app-loading-overlay></app-loading-overlay>
  }
  <main class="container-fluid flex-grow-1 px-0 overflow-hidden">
    <router-outlet />
  </main>
  <app-bottom-nav></app-bottom-nav>
</div>
